// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 20\" preserveAspectRatio=\"none\"><path d=\"M0,20 L0,15 L5,15 L5,10 L10,10 L10,15 L15,15 L15,5 L20,5 L20,15 L25,15 L25,8 L30,8 L30,15 L35,15 L35,12 L40,12 L40,15 L45,15 L45,0 L50,0 L50,15 L55,15 L55,10 L60,10 L60,15 L65,15 L65,5 L70,5 L70,15 L75,15 L75,8 L80,8 L80,15 L85,15 L85,12 L90,12 L90,15 L95,15 L95,18 L100,18 L100,20 Z\" fill=\"%238fd49b\" opacity=\"0.6\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Poppins", sans-serif;
  padding: 0;
  margin: 0;
  font-size: 15px;
}



/* Travel Portal Support Widget */
.travel-support-widget {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1.5px solid #28a745;
  border-radius: 50px;
  padding: 10px 15px;
  background-color: #fff;
  width: 100%;
  max-width: 320px;
  margin: 0;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  text-decoration: none;
}

.mobile-text,
.mobile-icon {
  display: none;
}

.travel-support-widget:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-decoration: none;
}

.travel-support-widget::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20%;
  right: 20%;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom center;
  z-index: 1;
}

.travel-support-widget-left {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: transparent;
  box-shadow: 0 0 0 1px #28a745, 0 0 0 3px #fff, 0 0 0 5px #d4f0db;
  z-index: 2;
  margin-left: 5px;
}

.travel-support-widget-left .icon {
  color: #28a745;
  font-size: 22px;
  transform: rotate(-10deg);
}

.travel-support-widget-center {
  flex: 1 1;
  text-align: center;
  padding: 0 10px;
  z-index: 2;
}

.travel-support-widget-center h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1b8a33;
}

.travel-support-widget-center p {
  margin: 0;
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
}

.travel-support-widget-right {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #28a745;
  z-index: 2;
}

.travel-support-widget-right .icon {
  color: #fff;
  font-size: 16px;
}

/* Responsiveness */
@media (max-width: 768px) {

  .desktop-text,
  .desktop-icon {
    display: none !important;
  }

  .mobile-text,
  .mobile-icon {
    display: block !important;
  }

  .travel-support-widget-center h4 {
    font-size: 11px;
  }

  .travel-support-widget-center p {
    font-size: 9px;
  }

  .travel-support-float-container {
    bottom: 20px;
    right: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .travel-support-widget {
    flex-direction: row;
    background-color: transparent;
    border: none;
    box-shadow: none;
    padding: 0;
    width: auto;
    height: auto;
    align-items: center;
  }

  .travel-support-widget-left {
    display: none !important;
  }

  .travel-support-widget-center {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.85);
    padding: 10px 15px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-right: 15px;
    margin-top: 0;
    text-align: left;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
  }

  .travel-support-widget-center h4.mobile-text {
    font-size: 15px;
    font-weight: 700;
    color: #333;
    margin: 0 0 2px 0;
    background: none;
    padding: 0;
    box-shadow: none;
  }

  .travel-support-widget-center p.mobile-text {
    font-size: 14px;
    color: #444;
    margin: 0;
    font-weight: 400;
  }

  .travel-support-widget-right {
    display: flex !important;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #28a745;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }

  .travel-support-widget-right .icon {
    font-size: 26px;
    color: #fff;
  }

  .travel-support-widget::after {
    display: none !important;
  }

  .travel-support-widget {
    border-radius: 0px;
  }
}

.travel-support-float-container {
  position: fixed;
  bottom: 90px;
  right: 23px;
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kCAAkC;EAClC,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;;;AAIA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,yDAAqd;EACrd,4BAA4B;EAC5B,wBAAwB;EACxB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,gEAAgE;EAChE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;AACnB;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kCAA0B;YAA1B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap\");\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  padding: 0;\n  margin: 0;\n  font-size: 15px;\n}\n\n\n\n/* Travel Portal Support Widget */\n.travel-support-widget {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1.5px solid #28a745;\n  border-radius: 50px;\n  padding: 10px 15px;\n  background-color: #fff;\n  width: 100%;\n  max-width: 320px;\n  margin: 0;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  text-decoration: none;\n}\n\n.mobile-text,\n.mobile-icon {\n  display: none;\n}\n\n.travel-support-widget:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  text-decoration: none;\n}\n\n.travel-support-widget::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 20%;\n  right: 20%;\n  height: 18px;\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 20\" preserveAspectRatio=\"none\"><path d=\"M0,20 L0,15 L5,15 L5,10 L10,10 L10,15 L15,15 L15,5 L20,5 L20,15 L25,15 L25,8 L30,8 L30,15 L35,15 L35,12 L40,12 L40,15 L45,15 L45,0 L50,0 L50,15 L55,15 L55,10 L60,10 L60,15 L65,15 L65,5 L70,5 L70,15 L75,15 L75,8 L80,8 L80,15 L85,15 L85,12 L90,12 L90,15 L95,15 L95,18 L100,18 L100,20 Z\" fill=\"%238fd49b\" opacity=\"0.6\"/></svg>');\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: bottom center;\n  z-index: 1;\n}\n\n.travel-support-widget-left {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  background-color: transparent;\n  box-shadow: 0 0 0 1px #28a745, 0 0 0 3px #fff, 0 0 0 5px #d4f0db;\n  z-index: 2;\n  margin-left: 5px;\n}\n\n.travel-support-widget-left .icon {\n  color: #28a745;\n  font-size: 22px;\n  transform: rotate(-10deg);\n}\n\n.travel-support-widget-center {\n  flex: 1;\n  text-align: center;\n  padding: 0 10px;\n  z-index: 2;\n}\n\n.travel-support-widget-center h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #1b8a33;\n}\n\n.travel-support-widget-center p {\n  margin: 0;\n  font-size: 12px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.travel-support-widget-right {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #28a745;\n  z-index: 2;\n}\n\n.travel-support-widget-right .icon {\n  color: #fff;\n  font-size: 16px;\n}\n\n/* Responsiveness */\n@media (max-width: 768px) {\n\n  .desktop-text,\n  .desktop-icon {\n    display: none !important;\n  }\n\n  .mobile-text,\n  .mobile-icon {\n    display: block !important;\n  }\n\n  .travel-support-widget-center h4 {\n    font-size: 11px;\n  }\n\n  .travel-support-widget-center p {\n    font-size: 9px;\n  }\n\n  .travel-support-float-container {\n    bottom: 20px;\n    right: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .travel-support-widget {\n    flex-direction: row;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    padding: 0;\n    width: auto;\n    height: auto;\n    align-items: center;\n  }\n\n  .travel-support-widget-left {\n    display: none !important;\n  }\n\n  .travel-support-widget-center {\n    display: flex !important;\n    flex-direction: column;\n    justify-content: center;\n    background-color: rgba(255, 255, 255, 0.85);\n    padding: 10px 15px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    margin-right: 15px;\n    margin-top: 0;\n    text-align: left;\n    backdrop-filter: blur(5px);\n  }\n\n  .travel-support-widget-center h4.mobile-text {\n    font-size: 15px;\n    font-weight: 700;\n    color: #333;\n    margin: 0 0 2px 0;\n    background: none;\n    padding: 0;\n    box-shadow: none;\n  }\n\n  .travel-support-widget-center p.mobile-text {\n    font-size: 14px;\n    color: #444;\n    margin: 0;\n    font-weight: 400;\n  }\n\n  .travel-support-widget-right {\n    display: flex !important;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: #28a745;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  }\n\n  .travel-support-widget-right .icon {\n    font-size: 26px;\n    color: #fff;\n  }\n\n  .travel-support-widget::after {\n    display: none !important;\n  }\n\n  .travel-support-widget {\n    border-radius: 0px;\n  }\n}\n\n.travel-support-float-container {\n  position: fixed;\n  bottom: 90px;\n  right: 23px;\n  z-index: 1000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
